var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-crop" }, [
    _c("img", {
      directives: [
        {
          name: "crop",
          rawName: "v-crop",
          value: _vm.options,
          expression: "options"
        }
      ],
      staticClass: "vue-crop-photo",
      attrs: { src: _vm.url + "?" + _vm.hash }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "vue-crop-container" }, [
      _c(
        "button",
        { staticClass: "oc-settings-btn", on: { click: _vm.cropPhoto } },
        [_vm._v("Загрузить")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dec747c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dec747c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/form/CropPhoto.vue
// module id = 128
// module chunks = 0